import { createSlice } from "@reduxjs/toolkit";
import Api from "../api/Api";

type State = {
  active: boolean | null;
  isLoading: boolean;
  error: Object | null;
};

const INITIAL_STATE: State = {
  active: null,
  isLoading: false,
  error: null,
};

const cdnStatus = createSlice({
  name: "cdnStatus",
  initialState: INITIAL_STATE,
  reducers: {
    fetchCdnStatusStart(state: State) {
      state.isLoading = true;
      state.error = null;
    },
    fetchCdnStatusSuccess(state: State, action) {
      state.isLoading = false;
      state.active = action.payload.active;
      state.error = null;
    },
    fetchCdnStatusFailed(state: State, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetCdnStatus(state: State) {
      state.active = null;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export default cdnStatus.reducer;

export const {
  fetchCdnStatusStart,
  fetchCdnStatusSuccess,
  fetchCdnStatusFailed,
  resetCdnStatus,
} = cdnStatus.actions;

export const fetchCdnStatus = (brandId: string) => {
  return async (dispatch: any) => {
    dispatch(fetchCdnStatusStart());
    try {
      const api = new Api();
      const response = await api.getCheckCdnActive(brandId);
      dispatch(fetchCdnStatusSuccess(response));
    } catch (error) {
        console.log(error);
      dispatch(fetchCdnStatusFailed(error));
    }
  };
};
